// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOtpRequestBody = {
  email: string;
  client?: "ios" | "android" | "web" | "unknown";
  recaptchaToken?: string | null;
  appAttestToken?: string | null;
  playIntegrityToken?: string | null;
};

export type typeOtpRequestOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    requestId: string;
    expiresInSeconds: number;
    testCode?: string | null;
    nextRequestAllowedAt: string;
  };
};

export type typeOtpRequestOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOtpRequestOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOtpRequestOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOtpRequestBody = {
  type: "object",
  properties: {
    email: { type: "string", maxLength: 3000, minLength: 1 },
    client: { type: "string", enum: ["ios", "android", "web", "unknown"] },
    recaptchaToken: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    appAttestToken: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    playIntegrityToken: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["email"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOtpRequest(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOtpRequestBody);
  }

  return async function postOtpRequest(
    payload: typeOtpRequestBody,
  ): Promise<typeOtpRequestOutput200 | typeOtpRequestOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOtpRequest" failed before calling the network. #cabcfe1543a6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cabcfe1543a6" },
        },
        data: null,
      } as typeOtpRequestOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/otp/request`,
      httpMethod: "POST",
      options,
    })) as typeOtpRequestOutput200 | typeOtpRequestOutput400;
  };
}
